module.exports = __webpack_public_path__ + "static/media/it-82.dc7a07c2.svg";